<div class="container">
    <!-- <a class="mainHeader-logo" href="<?=DC_Rutas::getRuta(ID_PAGINA_INICIO)?>" title=""> -->
    <a class="mainHeader-logo" routerLink="/" title="">
        <picture>
            <img class="color" src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL"/>
            <img class="negative" src="assets/images/icons/logo-neg.svg" alt="'NOMBRE COMERCIAL"/>
        </picture>
    </a>
    <div class="mainHeader-menuInline" *ngIf="menuInline">
        <neo-menu-dropdown  [elementos]="elementosMenu"></neo-menu-dropdown>
    </div>

    <!--  menuIdiomas-->
    <div class="mainHeader-idiomas"  *ngIf="menuIdiomas">
        <neo-menu-dropdown [elementos]="elementosIdioma"></neo-menu-dropdown>
    </div>

    <div class="mainHeader-cta" *ngIf="buttonCta">
        <ng-container
            *ngIf="configuracionButtonCta?.otroUso && !configuracionButtonCta.otroUso; else mainHeaderCtaPersonalizado">
            <neo-main-header-cta></neo-main-header-cta>
        </ng-container>
        <ng-template #mainHeaderCtaPersonalizado>
            <neo-main-header-cta [url]="configuracionButtonCta?.url" [path]="configuracionButtonCta?.path"
                [label]="configuracionButtonCta?.label" [target]="configuracionButtonCta?.target"
                [iconoClase]="configuracionButtonCta?.iconoClase">
            </neo-main-header-cta>
        </ng-template>
    </div>
    <div class="mainHeader-user"  *ngIf="menuUser">
        <neo-menu-user></neo-menu-user>
    </div>
    <ng-template [ngTemplateOutlet]="customProyeccion || defaultTemplate">
    </ng-template>
    <ng-template #defaultTemplate></ng-template>
    <!-- [ngTemplateOutletContext]="{trackByWeekDayHeaderDate: trackByWeekDayHeaderDate}" -->
    <ng-content></ng-content>
    <div class="mainHeader-ue">
        <img class="img-responsive" (click)="verInformacionUE()" src="assets/images/logo-ue.png"
        alt="Unión Europea" />
    </div>
    <div class="mainHeader-menuBurger" *ngIf="menuBurger">
        <neo-menu-burger [elementos]="elementosMenu" [buttonCta]="buttonCta" [configuracionButtonCta]="configuracionButtonCta"
            [customProyeccion]="customProyeccion">
        </neo-menu-burger>
    </div>
</div>

<ng-template #dialogoInformacionUE>
    <neo-acciones-dialog #accionDialogoInformacionUE [dialogTittle]="''" [botonera]="[]">
        <img class="img-responsive" src="assets/images/ue-ayuda.svg" alt="">
    </neo-acciones-dialog>
</ng-template>